import Vue from 'vue'

export default {
  setOwnedPlaces: (state, value) => {
    state.ownedPlaces = value
  },
  setPlaces: (state, value) => {
    state.places = value
  },
  setPlace: (state, value) => {
    state.place = value
  },
  setTotalSpots: (state, value) => {
    state.totalSpots = value
  },
  setAvailableSpots: (state, value) => {
    state.availableSpots = value
  },
  setSessions: (state, value) => {
    state.sessions = value
  },
  addSession: (state, value) => {
    const exists = state.sessions.some(sess => {
      return sess.Id === value.Id
    })
    if (!exists) {
      state.sessions.push(value)
    }
  },
  setSessionInSessionsArray: (state, payload) => {
    const existingSession = state.sessions.find(
      session => session.Id === payload.Id
    )
    Object.assign(existingSession, payload)
  },
  setSessionKeyValueInSessionsArray: (state, payload) => {
    const existingSession = state.sessions.find(
      session => session.Id === payload.SessionId
    )
    Vue.set(existingSession, payload.key, payload.value)
  },
  setNextAvailablePage: (state, value) => {
    state.nextAvailablePage = value
  },
  removeSessionFromSessionsArray: (state, sessionId) => {
    state.sessions = state.sessions.filter(session => session.Id !== sessionId)
  }
}
